import React, { useState } from 'react';
import { Image, Box, Spinner, Center, Tooltip } from '@chakra-ui/react';

export const LazyImg = ({ image, title, setSelectedImg }) => {
  const [loading, setLoading] = useState(true);
  return (
    <Center>
      <Tooltip label={title} fontSize="md" placement="top">
        <Box
          mr={4}
          ml={4}
          borderRadius="2xl"
          borderColor="transparent"
          borderWidth="4px"
          overflow="hidden"
          transition=".1s linear"
          cursor="pointer"
          _hover={{ borderColor: 'blue.200' }}
          onClick={() => setSelectedImg(image)}
        >
          <Image
            src={image}
            onLoad={() => setLoading(false)}
            display={loading ? 'none' : 'block'}
            objectFit="cover"
            transition=".1s linear"
            height={{ base: '200px', md: '250px' }}
          />
        </Box>
      </Tooltip>
      <Center height={{ base: '200px', md: '350px' }}>
        <Spinner
          display={loading ? 'block' : 'none'}
          transition=".1s linear"
          size="xl"
        />
      </Center>
    </Center>
  );
};
